import { h, defineComponent, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import ReTooltip from '@/elements/ReTooltip.vue'

export const registerBorrowerColumn = (dashboard, { requests }) => {
  const { t } = useI18n()
  dashboard.registerCustomColumn({
    name: 'borrower',
    label: 'monolith.shared.borrower',
    component: defineComponent({
      setup(ctx, { attrs }) {
        const isEmpty = computed(() => {
          return !(attrs.row.borrower && attrs.row.owner?.id !== attrs.row.borrower.id)
        })

        const isOnlyEmail = computed(() => {
          return attrs.row?.referral_at == null
        })

        const hasLoggedInAfterInvite = computed(
          () => new Date(attrs.row.borrower?.last_login_at) >= attrs.row?.referral_at
        )
        return () =>
          !isEmpty.value
            ? isOnlyEmail.value
              ? h(
                  'div',
                  {
                    class: 'text-break-word',
                    style: 'word-break: break-all; max-width: 150px;',
                  },
                  `${attrs.row.borrower.email}`
                )
              : h(
                  ReTooltip,
                  {
                    style: 'word-break: break-all; max-width: 150px;',
                    icon: hasLoggedInAfterInvite.value ? 'mdi-eye-outline' : 'mdi-eye-off-outline',
                    label: t(
                      hasLoggedInAfterInvite.value
                        ? 'monolith.dashboard.has_logged_in_after_invite'
                        : 'monolith.dashboard.has_not_logged_in_after_invite',
                      { username: attrs.row.borrower.email }
                    ),
                  },
                  () => h('span', { style: 'word-break: break-all;' }, attrs.row.borrower.email)
                )
            : null
      },
    }),
    options: {
      searchable: true,
      filter: 'borrower__info',
      visible: computed(() => {
        return (
          !requests.data.value?.length ||
          requests.data.value?.some(
            (request) =>
              request.borrower &&
              !request.borrower.is_self && // Show only if not the current user
              request.owner?.id !== request.borrower.id // Show only if owner and borrower are different
          )
        )
      }),
    },
  })
}
